import React from 'react';
import { SignupData } from '../../pages/SignupPage';
import { CheckCircleIcon } from 'lucide-react';
interface ProfileTypeSelectionProps {
  onNext: () => void;
  onBack: () => void;
  updateData: (data: Partial<SignupData>) => void;
  selectedType: string;
}
const ProfileTypeSelection: React.FC<ProfileTypeSelectionProps> = ({
  onNext,
  onBack,
  updateData,
  selectedType
}) => {
  const profileTypes = [{
    id: 'player',
    name: 'Player',
    icon: '⚽',
    description: 'Professional or amateur athlete'
  }, {
    id: 'coach',
    name: 'Coach',
    icon: '🏆',
    description: 'Team or individual coach'
  }, {
    id: 'manager',
    name: 'Manager',
    icon: '💼',
    description: 'Team or sports manager'
  }, {
    id: 'agent',
    name: 'Agent',
    icon: '🤝',
    description: 'Sports agent or representative'
  }, {
    id: 'scout',
    name: 'Scout',
    icon: '🔍',
    description: 'Talent scout or recruiter'
  }, {
    id: 'referee',
    name: 'Referee',
    icon: '👨‍⚖️',
    description: 'Official or referee'
  }, {
    id: 'journalist',
    name: 'Journalist',
    icon: '📝',
    description: 'Sports journalist or reporter'
  }, {
    id: 'fan',
    name: 'Fan',
    icon: '👏',
    description: 'Sports fan or enthusiast'
  }];
  const handleSelectType = (typeId: string) => {
    updateData({
      profileType: typeId
    });
  };
  const handleSubmit = () => {
    if (selectedType) {
      onNext();
    }
  };
  return <div className="p-4" data-id="element-205">
      <h2 className="text-xl font-bold text-center mb-2" data-id="element-206">
        Choose Your Profile Type
      </h2>
      <p className="text-gray-600 text-center mb-6" data-id="element-207">
        Select the type that best describes your role in sports
      </p>
      <div className="grid grid-cols-2 gap-4" data-id="element-208">
        {profileTypes.map(type => <button key={type.id} className={`
              relative flex flex-col items-center justify-center p-4 rounded-lg border
              ${selectedType === type.id ? 'border-blue-500 bg-blue-50' : 'border-gray-200 bg-white'}
            `} onClick={() => handleSelectType(type.id)} data-id="element-209">
            {selectedType === type.id && <div className="absolute top-2 right-2 text-blue-500" data-id="element-210">
                <CheckCircleIcon size={16} fill="currentColor" data-id="element-211" />
              </div>}
            <span className="text-2xl mb-2" data-id="element-212">{type.icon}</span>
            <span className="font-medium" data-id="element-213">{type.name}</span>
            <span className="text-xs text-gray-500 text-center mt-1" data-id="element-214">
              {type.description}
            </span>
          </button>)}
      </div>
      <div className="mt-6" data-id="element-215">
        <button onClick={handleSubmit} disabled={!selectedType} className={`
            w-full py-3 rounded-lg font-medium text-white
            ${selectedType ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-300 cursor-not-allowed'}
          `} data-id="element-216">
          Continue
        </button>
      </div>
    </div>;
};
export default ProfileTypeSelection;